import { DocumentationPage } from './_article.jsx';
export default function RssAndDistributionPage({
  article,
  articles
}) {
  return <DocumentationPage article={article} articles={articles} />;
}